<template>
    <div>

        <label class="form-label" :for="name"><slot /></label>

        <input
            :value="value"
            @input="$emit('input', $event.target.value)"
            :id="name" class="form-control" :placeholder="placeholder"
            :type="type"
            :class="{'invalid': errors}"
            :name="name"
            min="0"
        >
        <div class="text-danger text-center">
            {{ errors }}
        </div>
    </div>
</template>

<script>
export default {
    name: "InputField",
    props: {
        value: {
            required: true,
        },
        errors: {
            type: String,
            required: false
        },
        placeholder: {
            type: String,
            required: false,
            default: 'Enter value'
        },
        type: {
            required: false,
            default: 'text'
        },
        name: {
            type: String,
            required: true
        }
    },
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

label {
    @include font($mulish-bold, 18px, 30px, $hajde-pink);
}

.invalid{
    border-color: #dc3545!important;
    padding-right: calc(1.5em + 0.75rem) !important;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right calc(0.375em + 0.1875rem) center;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

input {
    padding: 15px 20px;
    border-radius: 15px;
    border: 1px solid rgba(109, 110, 112, 0.5);
    @include font($mulish-light, 18px, 30px, $hajde-black);

    &::placeholder {
        @include font($mulish-light, 18px, 30px, $hajde-black);
        opacity: 50%;
    }
}
</style>
